var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRelated01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.55.623.226 7.755l5.903 5.903 7.326-7.132-.671-5.232zm3.757 3.22a.759.759 0 1 0-1.074-1.073.759.759 0 0 0 1.074 1.073",
  clipRule: "evenodd"
})));
export default SvgIconRelated01;